import { useLocation, useParams } from 'react-router-dom';

export default function Placeholder({ name }: { name: string }) {
  const { pathname } = useLocation();
  const params = useParams();
  return (
    <main className="min-h-screen flex items-center justify-center bg-background text-foreground p-6">
      <div className="text-center space-y-2 max-w-md">
        <p className="text-xs uppercase tracking-widest text-accent">Placeholder</p>
        <h1 className="text-2xl font-bold">{name}</h1>
        <p className="text-sm text-muted-foreground">{pathname}</p>
        {Object.keys(params).length > 0 && (
          <pre className="text-xs text-muted-foreground bg-muted p-2 rounded">
            {JSON.stringify(params, null, 2)}
          </pre>
        )}
      </div>
    </main>
  );
}
